import React from "react";
import {
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { NavLink } from "react-router-dom";

const SettingsDropdown = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title="Settings">
        <IconButton
          color="inherit"
          aria-label="settings"
          aria-controls={open ? "settings-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleOpen}
          sx={{
            borderRadius: 2,
            "&:hover": { bgcolor: "rgba(255, 255, 255, 0.98)" },
          }}
        >
          <SettingsRoundedIcon />
        </IconButton>
      </Tooltip>

      <Menu
        id="settings-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "settings-button" }}
        PaperProps={{
          elevation: 6,
          sx: {
            mt: 1,
            minWidth: 220,
            borderRadius: 2,
            border: "1px solid rgba(255, 255, 255, 1)",
            bgcolor: "rgba(255, 255, 255, 0.98)",
            backdropFilter: "blur(6px)",
            "& .MuiMenuItem-root": { py: 1 },
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {/* Primary item requested */}
        <MenuItem
          component={NavLink}
          to="/home/settings/leaveroles"
          onClick={handleClose}
          sx={{ "&.active": { bgcolor: "rgba(255, 255, 255, 0.97)" } }}
        >
          <ListItemIcon>
            <GroupRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Leave roles" />
        </MenuItem>
        
        <MenuItem
          component={NavLink}
          to="/home/settings/visitroles"
          onClick={handleClose}
          sx={{ "&.active": { bgcolor: "rgba(255, 255, 255, 0.97)" } }}
        >
          <ListItemIcon>
            <GroupRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Visit roles" />
        </MenuItem> 

        <MenuItem
          component={NavLink}
          to="/home/settings/notificationroles"
          onClick={handleClose}
          sx={{ "&.active": { bgcolor: "rgba(255, 255, 255, 0.97)" } }}
        >
          <ListItemIcon>
            <GroupRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Other roles" />
        </MenuItem> 

      </Menu>
    </>
  );
};

export default SettingsDropdown;
